import React from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TextOption } from '../../types/onboarding';

interface SingleChoiceProps {
  questionTextKey: string;
  options: TextOption[];
  value?: string;
  onChange: (value: string) => void;
}

const SingleChoice: React.FC<SingleChoiceProps> = ({
  options,
  value,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
        maxWidth: '400px',
        margin: '0 auto',
      }}
    >
      {options.map((option) => (
        <Button
          key={option.value}
          onClick={() => onChange(option.value)}
          variant={value === option.value ? 'contained' : 'outlined'}
          sx={{
            width: '100%',
            py: 2,
            px: 3,
            borderRadius: 3,
            textTransform: 'none',
            fontSize: '1rem',
            fontWeight: 500,
            justifyContent: 'flex-start',
            backgroundColor: value === option.value ? 'white' : 'transparent',
            color: value === option.value ? 'black' : 'white',
            border: '2px solid',
            borderColor: value === option.value ? 'white' : 'rgba(255, 255, 255, 0.5)',
            '&:hover': {
              backgroundColor: value === option.value ? 'white' : 'rgba(255, 255, 255, 0.1)',
              borderColor: 'white',
            },
          }}
        >
          {t(option.optionTextKey)}
        </Button>
      ))}
    </Box>
  );
};

export default SingleChoice; 